import withAemIntegration from "../../withAemIntegration";
import loadable from "../../utils/loadable";

const Component = loadable(() =>
  import("@lexus.com/ui/dist/_nextgen/components/ModelHero")
);

const ComponentEditConfig = {
  emptyLabel: "Model Hero",
  isEmpty: function (props) {
    return !props || !props.title || props.title.trim().length < 1;
  },
};

const transformData = (props) => {
  
  return {
    id: props?.id,
    containerHeading: props?.heading,
		containerHeadingColor: props?.headingColor,
		containerSubHeading: props?.subHeading,
		containerSubHeadingColor: props?.subHeadingColor,
    heading: props?.heroHeading,
    subHeading: props?.bottomHeading,
    variationTwo: props?.variationTwo,
    topHeading: props?.topHeading,
    headingsColor: props?.headingsColor,
    media: props?.media,
    ctas: props?.ctas,
    price: props?.price,
    pricesColor: props?.pricesColor,
    pricesOpacity: props?.pricesOpacity,
    additionalMsgContainerColor: props?.additionalMsgContainerColor,
    additionalMsgColor: props?.additionalMsgColor,
    additionalMessaging: props?.additionalMessaging,
    ribbonColor: props?.ribbonColor,
    ribbonCopy: props?.ribbonCopy,
    ribbonCopyColor: props?.ribbonCopyColor,
  };
};

const ModelHero = (props) => {
  const data = transformData(props);
  return <Component {...data}/>;
};

export default withAemIntegration("lexus/components/content/model-hero")(
  ModelHero,
  ComponentEditConfig
);
